<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_InvoicingInformation')"
    width="1000px"
    :close-on-click-modal="false"
  >
    <cargo-ag-grid
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      :wrap-text="true"
      style="height: 400px;min-height: 400px;"
      @gridReady="params=>{gridApi=params.api}"
    />
    <span slot="footer">
      <el-button :disabled="!selectedNode" type="primary" @click="setAsDefault">{{ $t('CargoMsg.Cargo_SetAsDefault') + $t('CargoMsg.Cargo_InvoicingInformation') }}</el-button>
      <el-button type="primary" @click="toAdd">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
      <el-button :disabled="!selectedNode" type="danger" @click="toDelete">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
      <el-button type="primary" @click="toSave">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
      <el-button type="primary" @click="innerVisible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import CargoAgGridAdvanceMultipleSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceMultipleSelectEditor'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { OfficeInvoiceTitle } from '@/class/model/sys/OfficeInvoiceTitle'
import { getInvoiceTitlesByOffice, saveInvoiceTitle } from '@/api/sysManage/officeInvoiceTitle'

export default {
  name: 'InvoicingInfoDialog',
  props: {
    visible: { type: Boolean, required: true },
    office: { type: Object, required: true },
    taxControlPanels: { type: Array, required: true }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        frameworkComponents: {
          CargoAgGridCommonInputEditor,
          CargoAgGridCommonTextareaEditor,
          CargoAgGridAdvanceMultipleSelectEditor
        },
        singleClickEdit: true,
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        onRowDataChanged: event => {
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          if (this.selectedNode) {
            event.api.setFocusedCell(this.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_InvoiceHeader'),
          field: 'invoiceTitle',
          width: 220,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: false,
            inputProps: {
              maxLength: 64
            }
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_RegistrationNumber'),
          field: 'taxAccount',
          width: 180,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: false,
            inputProps: {
              maxLength: 255
            }
          }
        }, {
          headerName: this.$t('Partners.invoiceAddress'),
          field: 'invoiceAddress',
          width: 180,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: false,
            inputProps: {
              maxLength: 64
            }
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_EnterpriseWechatApprovalPayCompany'),
          field: 'enterpriseWechatPayCompany',
          width: 180,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: false,
            inputProps: {
              maxLength: 64
            }
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_TaxControlMachineNo'), field: 'taxControlPanelUuidList',
          colId: 'taxControlPanelUuidList', width: 350,
          editable: true,
          valueFormatter: (params) => {
            return this.taxControlPanelUuidLabFunc(params.data)
          },
          cellEditor: 'CargoAgGridAdvanceMultipleSelectEditor',
          cellEditorParams: {
            selectProps: {
              multiple: true,
              tagValue: 'uuid',
              tagName: 'taxPanelNo',
              staticOptions: [...this.taxControlPanels],
              filterable: true,
              filterTagNames: ['taxPanelNo']
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }, {
          headerName: this.$t('CargoMsg.Cargo_Tel'),
          field: 'phone',
          width: 148,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: false,
            inputProps: {
              maxLength: 32
            }
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_DefaultOrNot'),
          field: 'isDefault',
          width: 100,
          valueFormatter: params => {
            return params.value ? '√' : ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Payee'),
          field: 'payee',
          width: 100,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: false
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ApprovedBy'),
          field: 'auditor',
          width: 100,
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: false
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_DepositBankAndAccountNo'),
          field: 'depositBankAccount',
          width: 180,
          editable: true,
          cellEditor: 'CargoAgGridCommonTextareaEditor',
          cellEditorParams: {
            inputProps: {
              maxlength: 256
            }
          }
        }
      ],
      rowData: [],
      selectedNode: null,
      gridApi: null,
      deletedKeys: []
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          const loading = getLoading4Cxt(this)
          getInvoiceTitlesByOffice({ officeId: this.office.officeId }).then(res => {
            this.rowData = res.data
          }).finally(() => {
            loading.close()
          })
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.rowData = []
        this.deletedKeys = []
      }
    }
  },
  methods: {
    setAsDefault() {
      const selectedData = this.selectedNode.data
      for (const item of this.rowData) {
        item.isDefault = item === selectedData
      }
      this.gridApi.refreshCells({ force: true })
    },
    toAdd() {
      const newRow = new OfficeInvoiceTitle().fillDefaultValue().getData()
      newRow.officeId = this.office.officeId
      this.rowData.push(newRow)
      if (this.rowData.length === 1) {
        this.rowData[0].isDefault = true
      }
      setTimeout(() => {
        const nodes = this.gridApi.rowModel.rowsToDisplay
        const index = nodes.findIndex(p => p.data === newRow)
        this.gridApi.setFocusedCell(index, this.gridApi.columnController.getAllDisplayedColumns()[0])
      }, 10)
    },
    toDelete() {
      const selectedData = this.selectedNode.data
      const index = this.rowData.findIndex(p => p === selectedData)
      if (this.rowData[index].uuid) {
        this.deletedKeys.push(this.rowData[index].uuid)
      }
      this.rowData.splice(index, 1)
      if (this.rowData.length === 1) {
        this.rowData[0].isDefault = true
      }
    },
    toSave() {
      const titleSet = new Set()
      for (const item of this.rowData) {
        if (!item.invoiceTitle) {
          this.$message.warning(this.$t('CargoMsg.InvoiceTitleCannotBeBlank'))
          return
        }
        if (titleSet.has(item.invoiceTitle)) {
          this.$message.warning(this.$t('CargoMsg.InvoiceTitleCannotBeDuplicate'))
          return
        }
        titleSet.add(item.invoiceTitle)
      }
      // 校验税盘号是否重复
      if (!this.checkTaxControlPanelRepeat()) {
        return
      }
      const loading = getLoading4Cxt(this)
      saveInvoiceTitle({ office: this.office, invoiceTitles: this.rowData, deletedKeys: this.deletedKeys }).then(res => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.innerVisible = false
        this.$emit('officeChange', res.data)
      }).finally(() => {
        loading.close()
      })
    },
    taxControlPanelUuidLabFunc(data) {
      const taxPanelNos = []
      if (data.taxControlPanelUuid) {
        const array = data.taxControlPanelUuid.split(',')
        for (const item of array) {
          for (const d of this.taxControlPanels) {
            if (item === d.uuid && d.taxPanelNo) {
              taxPanelNos.push(d.taxPanelNo)
            }
          }
        }
      }
      return taxPanelNos.join(',')
    },
    onCellChange(e) {
      const data = e.data
      if (data.taxControlPanelUuidList) {
        const taxControlPanelUuids = []
        for (const data of data.taxControlPanelUuidList) {
          if (!data) continue
          taxControlPanelUuids.push(data)
        }
        data.taxControlPanelUuid = taxControlPanelUuids.join(',')
      } else {
        data.taxControlPanelUuid = ''
      }
    },
    // 校验税盘号是否重复
    checkTaxControlPanelRepeat() {
      const taxControlPanelSet = new Set()
      for (const item of this.rowData) {
        if (!item.taxControlPanelUuid) continue // 为空的不处理
        const arr = item.taxControlPanelUuid.split(',') // 逗号隔开的税盘UUID
        if (!arr) continue
        for (const item of arr) { // 税盘UUID
          if (taxControlPanelSet.has(item)) {
            // 税盘信息里取税盘号
            for (const d of this.taxControlPanels) {
              if (item === d.uuid && d.taxPanelNo) {
                this.$message.warning(this.$t('CargoMsg.TaxControlPanelCannotBeDuplicate', [d.taxPanelNo]))
                return false
              }
            }
          }
          taxControlPanelSet.add(item)
        }
        delete item.taxControlPanelUuidList
      }
      return true
    }
  }
}
</script>
